export function autoContentTooltip() {
  return {
    restrict: 'E',
    scope: false,
    compile: function compile(tElement, tAttrs, transclude) {
      const tooltip = angular.element('<md-tooltip md-direction="left"></tooltip>');
      tooltip.addClass('fixed-max-width-tooltip lighter-grey-bg-tooltip tooltip-with-border');
      tooltip.append(tElement.siblings().clone());
      tElement.parent().append(tooltip);
    }
  };
}

